import React from 'react';

const BlockIslandPage = () => {
  return (
    <div className="page-container-wrapper max-width-default padding-default">
      <div className="page-header">
        <h1>
          <i className="fas fa-island-tropical"></i>
          Block Island
        </h1>
        <p>Discovering the beauty and charm of Block Island, Rhode Island.</p>
      </div>

      <div className="page-content">
        <div className="section">
          <div className="island-content">
            <p className="welcome-text">
              Block Island is a special place that holds a unique charm and beauty.
              Located off the coast of Rhode Island, this island paradise offers
              stunning landscapes, rich history, and unforgettable experiences.
            </p>

            <div className="island-description">
              <h3>About Block Island</h3>
              <p>
                Block Island, also known as New Shoreham, is a small island located
                about 13 miles south of the Rhode Island coast. Known for its dramatic
                bluffs, pristine beaches, and Victorian architecture, it's a place
                where time seems to slow down and natural beauty takes center stage.
              </p>
            </div>

            <div className="island-highlights">
              <h3>Island Highlights</h3>
              <div className="highlights-grid">
                <div className="highlight-item">
                  <h4><i className="fas fa-lighthouse"></i> Lighthouses</h4>
                  <p>Historic lighthouses including the famous Block Island North Light and Southeast Light</p>
                </div>
                
                <div className="highlight-item">
                  <h4><i className="fas fa-water"></i> Beaches</h4>
                  <p>Beautiful sandy beaches perfect for swimming, sunbathing, and beachcombing</p>
                </div>
                
                <div className="highlight-item">
                  <h4><i className="fas fa-hiking"></i> Nature</h4>
                  <p>Scenic hiking trails, wildlife refuges, and stunning coastal bluffs</p>
                </div>
                
                <div className="highlight-item">
                  <h4><i className="fas fa-home"></i> Victorian Charm</h4>
                  <p>Historic Victorian hotels and charming New England architecture</p>
                </div>
              </div>
            </div>

            <div className="personal-connection">
              <h3>Our Connection to Block Island</h3>
              <p>
                Block Island represents more than just a beautiful destination - it's a place
                that has created lasting memories and holds special meaning for our family.
                Whether it's the peaceful mornings watching the sunrise over the Atlantic
                or the simple pleasure of walking along the beach, Block Island offers
                a connection to nature and tranquility that's hard to find elsewhere.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlockIslandPage;